import { QuestionsCta } from "@/components/wpl/pricing/src/index.ts";
import { usePricingContentContext } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";

export const JpdQuestionsCta = () => {
    const content = usePricingContentContext();
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;

    const questionsCtaHref = `https://www.atlassian.com${useLocalizedHref(
        "/licensing/jira-product-discovery#jira-product-discovery"
    )}`;

    return (
        <QuestionsCta
            product={"Jira Product Discovery"}
            ctaHref={questionsCtaContent?.url ?? questionsCtaHref}
            questionsHeader={questionsCtaContent?.title ?? undefined}
            priceAndLicensingLinkText={questionsCtaContent?.text ?? undefined}
            questionsBody={questionsCtaContent?.valueProposition ?? undefined}
            imageHref={questionsCtaContent?.asset?.url}
        />
    );
};
